import { useEffect } from "react";
import { matchPath, useInRouterContext, useLocation } from "react-router-dom";

import { PAGE_URL } from "@/data_source/constants";
import ReportLoadingSkeleton from "@/pages/AppAuditManagementDetailV2/view/ReportLoadingSkeleton";

import { AppLoadingStore } from "@/stores/app-loading-store";

function GlobalAppLoading(): JSX.Element {
  useEffect(() => {
    AppLoadingStore.getInstance().add(true);
    return () => {
      AppLoadingStore.getInstance().add(false);
    };
  }, []);
  return <></>;
}

function RoutedAppLoading(): JSX.Element {
  const { pathname } = useLocation();
  return matchPath(PAGE_URL.AUDIT_MANAGEMENT_DETAILS, pathname) ? (
    <ReportLoadingSkeleton />
  ) : (
    <GlobalAppLoading />
  );
}

function AppLoading(): JSX.Element {
  // Keep the global store/cleanup for existing consumers. The report's auth,
  // lazy-route and workspace waits share its neutral, data-free placeholder.
  return useInRouterContext() ? <RoutedAppLoading /> : <GlobalAppLoading />;
}

export default AppLoading;
